import React from 'react';
import { APP_VERSION, getHolidayInfo } from '../utils/constants';

const SplashScreen = ({ theme }) => {
  const holidayInfo = getHolidayInfo();

  const blobs = [
    { x: 12, y: 12, size: 130, opacity: 0.07, delay: 0 },
    { x: 75, y: 8, size: 170, opacity: 0.05, delay: 0.5 },
    { x: 88, y: 42, size: 110, opacity: 0.07, delay: 1 },
    { x: 5, y: 58, size: 150, opacity: 0.04, delay: 1.5 },
    { x: 65, y: 78, size: 190, opacity: 0.06, delay: 0.8 },
    { x: 18, y: 88, size: 120, opacity: 0.05, delay: 1.2 },
  ];

  return (
    <div className="splash">
      {theme !== 'matrix' && blobs.map((blob, i) => (
        <div
          key={i}
          className="splash__blob"
          style={{
            left: `${blob.x}%`,
            top: `${blob.y}%`,
            width: blob.size,
            height: blob.size,
            opacity: blob.opacity,
            animationDelay: `${blob.delay}s`,
          }}
        />
      ))}

      <div className="splash__content">
        {holidayInfo && (
          <div className="splash__holiday">
            <div className="splash__holiday-text" style={{ color: 'var(--accent)' }}>
              {holidayInfo.text}
            </div>
            <div className="splash__holiday-icons">
              <ion-icon name={holidayInfo.icon} style={{ fontSize: 18, color: 'var(--accent)' }}></ion-icon>
            </div>
          </div>
        )}

        <div className="splash__glow-ring">
          <div className="splash__icon-card">
            <ion-icon name="school"></ion-icon>
          </div>
        </div>

        <h1 className="splash__title">Мой ИТИ ХГУ</h1>
        <p className="splash__subtitle">Твой университет в кармане</p>

        <div className="splash__loader">
          <div className="spinner"></div>
        </div>
      </div>

      <div className="splash__version">v{APP_VERSION}</div>
    </div>
  );
};

export default SplashScreen;
